import { BROWSER_STORAGE, BrowserStorage } from 'src/services/storages/storage';

export const sessionStorageService = new BrowserStorage(
  BROWSER_STORAGE.SessionStorage
);

Object.freeze(sessionStorageService);
